import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import { UserProvider } from './context/User';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { StatusProvider } from './context/Status';
import { ThemeProvider } from './context/Theme';
import AppRuntimeGuard from './components/AppRuntimeGuard';
import AppErrorBoundary from './components/AppErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <StatusProvider>
        <UserProvider>
          <AppRuntimeGuard>
            <AppErrorBoundary
              title='控制台初始化失败'
              stage='root_bootstrap'
              fullscreen
            >
              <BrowserRouter>
                <App />
                <ToastContainer />
              </BrowserRouter>
            </AppErrorBoundary>
          </AppRuntimeGuard>
        </UserProvider>
      </StatusProvider>
    </ThemeProvider>
  </React.StrictMode>
);
